import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchPurchaseOrdersByDate, fetchPurchaseOrders, fetchPurchaseOrderDetail,
  fetchPurchaseOrderList, setPurchaseOrdersFilter, selectPurchaseOrder,
  resetCurrentPurchaseOrder, deletePurchaseOrder, setDefaultDays, setDefaultOfForm,
  mergePurchaseOrders, approvePendingPO, emailPO } from '../../actions/purchaseOrders_actions';
import { fetchPurchaseOrdersByFilter, uploadPOImage, uploadPOPOD } from '../../actions/purchaseOrderList_actions';
import { setValue } from '../../actions/sales_actions';
import { printPurchaseOrder, printPurchaseOrderNoSubtotals } from '../../actions/print_actions';
import { fetchBaseUsers, checkPassword, clearCheckPassword } from '../../actions/settings_actions';
import PurchaseOrderList from '../../components/Purchase/purchaseOrderList';

const purchaseOrderList = reduxForm({
  form: 'purchaseOrderList',
  destroyOnUnmount: false,
})(PurchaseOrderList);

const selector = formValueSelector('purchaseOrderList');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  const FromDate = selector(state, 'FromDate');
  const ToDate = selector(state, 'ToDate');
  const Status = selector(state, 'Status');
  const Purchaser = selector(state, 'Purchaser');
  const ProductNum = selector(state, 'ProductNum');
  return {
    Days,
    FromDate,
    ToDate,
    Status,
    Purchaser,
    ProductNum,
    currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
    purchaseOrders: state.purchaseOrders.all,
    isLoading: state.purchaseOrders.isLoading,
    error: state.purchaseOrders.error,
    userPermissions: state.auth.userPermissions,

    purchaseOrderDetail: state.purchaseOrders.currentPurchaseOrderDetail,
    purchaseOrderDetailIsLoading: state.purchaseOrders.detailIsLoading,
    purchaseOrderDetailError: state.purchaseOrders.detailError,

    purchaseOrderList: state.purchaseOrders.purchaseOrderList,
    purchaseOrderListIsLoading: state.purchaseOrders.purchaseOrderListIsLoading,
    purchaseOrderListError: state.purchaseOrders.purchaseOrderListError,

    purchaseOrdersFilter: state.purchaseOrders.purchaseOrdersFilter,

    users: state.settings.all,
    usersIsLoading: state.settings.isLoading,
    usersError: state.settings.error,

    requestingPurchaseOrderPdf: state.print.requestingPurchaseOrderPdf,
    purchaseOrderPdf: state.print.purchaseOrderPdf,

    purchaseOrderPdfNs: state.print.purchaseOrderPdfNs,
    requestingPurchaseOrderPdfNs: state.print.requestingPurchaseOrderPdfNs,

    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,
    
    mergePurchaseOrderData: state.purchaseOrders.mergePurchaseOrderData,
    mergePurchaseOrderError: state.purchaseOrders.mergePurchaseOrderError,
    mergePurchaseOrderSuccess: state.purchaseOrders.mergePurchaseOrderSuccess,
    mergePurchaseOrderLoading: state.purchaseOrders.mergePurchaseOrderLoading,

  };
}

export default connect(mapStateToProps, {
  fetchPurchaseOrdersByDate,
  fetchPurchaseOrderList,
  fetchPurchaseOrders,
  selectPurchaseOrder,
  resetCurrentPurchaseOrder,
  setPurchaseOrdersFilter,
  deletePurchaseOrder,
  setDefaultDays,
  fetchPurchaseOrderDetail,
  setValue,
  fetchBaseUsers,
  fetchPurchaseOrdersByFilter,
  setDefaultOfForm,
  printPurchaseOrder,
  checkPassword,
  clearCheckPassword,
  printPurchaseOrderNoSubtotals,
  mergePurchaseOrders,
  approvePendingPO,
  emailPO,
  uploadPOImage,
  uploadPOPOD,
})(purchaseOrderList);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseOrderList.jsx